import { UnitStateKey } from '../../InProgressUnitsPanel/lessonStepState';

/** Human-readable UnitState from wire key (atest.Constants.UnitState). */
export function formatBackendUnitStateLabel(state: string | undefined): string {
    const s = (state ?? '').trim();
    switch (s) {
        case UnitStateKey.New:
            return 'New';
        case UnitStateKey.Reviewing:
            return 'Reviewing';
        case UnitStateKey.Ready:
            return 'Ready';
        case UnitStateKey.InProgress:
            return 'In Progress';
        case UnitStateKey.LessonsCompleted:
            return 'Lessons Completed';
        case UnitStateKey.Assessing:
            return 'Assessing';
        case UnitStateKey.Complete:
            return 'Complete';
        default:
            return s || 'Unknown';
    }
}

export function backendUnitDisplayLabel(unit: any): string {
    const title = (unit?.e251_Title ?? '').trim();
    if (title) return title;
    const topics = unit?.e251_Topics;
    if (Array.isArray(topics) && topics.length > 0) {
        return topics.filter(Boolean).join(', ');
    }
    return 'Unit';
}
